<template>
  <div class="synchromed-timeline">
    <timeline-template :timeline-data="timelineData" :timeline-guff="timelineGuff" :timeline-options="timelineOptions"></timeline-template>
  </div>
</template>

<script>
import deviceTimelineData from '../assets/device-timelines.json'
import deviceTimelineGuff from '../assets/device-timelines-guff.json'
import TimelineTemplate from '@/components/TimelineTemplate.vue'

const timelineData = deviceTimelineData[1],
  timelineGuff = deviceTimelineGuff["synchromed"],
  timelineOptions = {
  color: "#3B98AB"
}

export default {
  name: 'SynchromedTimeline',
  components: {
    TimelineTemplate
  },
  data () {
    return {
      timelineGuff,
      timelineData,
      timelineOptions
    }
  }
}
</script>
